export enum NotificationsPlatformAccessOperation {
    create = "95ee2d53-cc87-4af8-a5bd-e510caa38dc9",
    read = "bdcd5674-3c8e-48da-b6d6-d9b562b8c967",
    update = "3adc3b19-017b-49be-ac86-a3630fc5ecd7",
    delete = "fcf3c38c-25aa-4286-85ba-126a34693160",
}
